import React from "react";

import { Container } from "@components/Layout/Container";
import { Section } from "@components/Layout/Section";
import { CSSGrid } from "@components/Layout/CssGrid";

import type { CitesStaticHomePageQueryQuery } from "@www/graphql-types";

import { Header } from "./Header";
import * as Styled from "./Cities.styled";
import { CityList } from "./CityList";
const areas = CSSGrid.areas({ Header });

areas.all(({ Header }, { repeat }) => [repeat(Header, 12)]);
areas.smallTablet(({ Header }, { repeat }) => [repeat(Header, 8)]);
areas.smallDesktop(({ Header }, { repeat }) => [repeat(Header, 9)]);

export const Cities: React.FC<{
  query: CitesStaticHomePageQueryQuery;
}> = ({ query }) => {
  const node = query.prismicLandingPage;

  return (
    <Section overflowHidden>
      <Container>
        <Styled.Root>
          <CSSGrid
            areas={areas}
            areasProps={{
              Header: { title: node?.data.enjoy_service_title.text },
            }}
          />
          <CityList prismicCities={query.prismicLandingPage} />
        </Styled.Root>
      </Container>
    </Section>
  );
};
